export default "__VITE_PUBLIC_ASSET__df916b1b__"